export const TAILWIND_CONFIG = {
  darkMode: 'class' as const,
  theme: {
    extend: {
      fontFamily: { sans: ['Inter', 'system-ui', 'sans-serif'] },
      colors: {
        brand: {
          50: '#eef6ff', 100: '#d9eaff', 200: '#bcd9ff', 300: '#8ec2ff',
          400: '#59a1ff', 500: '#3b82f6', 600: '#1d5ed8', 700: '#1a4eb0',
        },
        th: {
          bg: 'var(--c-bg)',
          deep: 'var(--c-bg-deep)',
          card: 'var(--c-card)',
          'card-hover': 'var(--c-card-hover)',
          surface: 'var(--c-surface)',
          'surface-hover': 'var(--c-surface-hover)',
          input: 'var(--c-input)',
          border: 'var(--c-border)',
          'border-2': 'var(--c-border-2)',
          text: 'var(--c-text)',
          'text-2': 'var(--c-text-2)',
          'text-3': 'var(--c-text-3)',
          'text-4': 'var(--c-text-4)',
          panel: 'var(--c-panel)',
        },
      },
    },
  },
};

export const THEME_CSS = `
:root {
  --c-bg: #f8fafc;
  --c-bg-deep: #ffffff;
  --c-card: #ffffff;
  --c-card-hover: #f1f5f9;
  --c-surface: #f1f5f9;
  --c-surface-hover: #e2e8f0;
  --c-input: #e2e8f0;
  --c-border: #e2e8f0;
  --c-border-2: #cbd5e1;
  --c-text: #0f172a;
  --c-text-2: #334155;
  --c-text-3: #64748b;
  --c-text-4: #94a3b8;
  --c-panel: rgba(255, 255, 255, 0.95);
  --c-sidebar-from: #ffffff;
  --c-sidebar-to: #f8fafc;
  --c-glass-bg: rgba(255, 255, 255, 0.85);
  --c-glass-border: rgba(203, 213, 225, 0.5);
  --c-card-shadow: 0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04);
  --c-hover-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  --c-nav-active-bg: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.05));
  --c-nav-active-border: rgba(59, 130, 246, 0.15);
  --c-text-gradient-from: #3b82f6;
  --c-text-gradient-to: #7c3aed;
  --c-table-hover: rgba(59, 130, 246, 0.04);
}
.dark {
  --c-bg: #020617;
  --c-bg-deep: #0f172a;
  --c-card: rgba(15, 23, 42, 0.5);
  --c-card-hover: rgba(30, 41, 59, 0.4);
  --c-surface: rgba(30, 41, 59, 0.5);
  --c-surface-hover: rgba(51, 65, 85, 0.5);
  --c-input: rgba(51, 65, 85, 0.5);
  --c-border: rgba(30, 41, 59, 0.5);
  --c-border-2: rgba(51, 65, 85, 0.5);
  --c-text: #f8fafc;
  --c-text-2: #e2e8f0;
  --c-text-3: #94a3b8;
  --c-text-4: #64748b;
  --c-panel: rgba(2, 6, 23, 0.95);
  --c-sidebar-from: #0f172a;
  --c-sidebar-to: #020617;
  --c-glass-bg: rgba(15, 23, 42, 0.8);
  --c-glass-border: rgba(71, 85, 105, 0.3);
  --c-card-shadow: none;
  --c-hover-shadow: 0 8px 30px -6px rgba(0, 0, 0, 0.5);
  --c-nav-active-bg: linear-gradient(135deg, rgba(59, 130, 246, 0.15), rgba(139, 92, 246, 0.08));
  --c-nav-active-border: rgba(59, 130, 246, 0.2);
  --c-text-gradient-from: #60a5fa;
  --c-text-gradient-to: #a78bfa;
  --c-table-hover: rgba(59, 130, 246, 0.04);
}
`;

export const BASE_CSS = `
* { -webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; }
::-webkit-scrollbar { width: 6px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb { background: var(--c-border-2); border-radius: 3px; }
::-webkit-scrollbar-thumb:hover { background: var(--c-text-4); }

.page-enter { animation: fadeIn 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
@keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }
@keyframes pulse-ring { 0% { transform: scale(1); opacity: 1; } 100% { transform: scale(2.5); opacity: 0; } }
@keyframes shimmer { 0% { background-position: -200% 0; } 100% { background-position: 200% 0; } }
@keyframes gradient-rotate { 0% { --angle: 0deg; } 100% { --angle: 360deg; } }
@keyframes float { 0%, 100% { transform: translateY(0px); } 50% { transform: translateY(-3px); } }
@keyframes glow-pulse { 0%, 100% { opacity: 0.4; } 50% { opacity: 0.8; } }

.pulse-dot::before { content: ''; position: absolute; inset: -4px; border-radius: 50%; animation: pulse-ring 2s ease-out infinite; }
.pulse-dot.green::before { background: rgba(34,197,94,0.4); }
.pulse-dot.yellow::before { background: rgba(234,179,8,0.4); }
.pulse-dot.red::before { background: rgba(239,68,68,0.4); }

.card-glow { position: relative; overflow: hidden; box-shadow: var(--c-card-shadow); }
.card-glow::before { content: ''; position: absolute; inset: 0; border-radius: inherit; padding: 1px; background: linear-gradient(135deg, rgba(59,130,246,0.3), transparent, rgba(139,92,246,0.2)); -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0); -webkit-mask-composite: xor; mask-composite: exclude; pointer-events: none; opacity: 0; transition: opacity 0.3s; }
.card-glow:hover::before { opacity: 1; }

.stat-card { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); box-shadow: var(--c-card-shadow); }
.stat-card:hover { transform: translateY(-2px); box-shadow: var(--c-hover-shadow); }

.nav-link-active { background: var(--c-nav-active-bg); border: 1px solid var(--c-nav-active-border); }

.glass { background: var(--c-glass-bg); backdrop-filter: blur(12px) saturate(1.5); border: 1px solid var(--c-glass-border); }

.text-gradient { background: linear-gradient(135deg, var(--c-text-gradient-from), var(--c-text-gradient-to)); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text; }

.live-dot { width: 6px; height: 6px; border-radius: 50%; background: #22c55e; box-shadow: 0 0 6px rgba(34, 197, 94, 0.6); animation: glow-pulse 2s ease-in-out infinite; }

.sidebar-bg { background: linear-gradient(180deg, var(--c-sidebar-from) 0%, var(--c-sidebar-to) 100%); }

table tbody tr { transition: all 0.15s ease; }
table tbody tr:hover { background: var(--c-table-hover); }

.badge-glow { box-shadow: 0 0 8px rgba(239, 68, 68, 0.3); }

/* Mobile bottom nav */
@media (max-width: 767px) {
  #app { flex-direction: column; }
  #app > aside { display: none; }
  #mobile-nav { display: flex; }
  #content { height: calc(100% - 56px) !important; }
  .resolve-btn { opacity: 1 !important; }
}
@media (min-width: 768px) {
  #mobile-nav { display: none !important; }
}
`;

export const LEAFLET_CSS = `
.leaflet-container { background: var(--c-bg); }
.leaflet-control-zoom a { background: var(--c-glass-bg) !important; color: var(--c-text-2) !important; border-color: var(--c-glass-border) !important; backdrop-filter: blur(8px); }
.leaflet-control-zoom a:hover { background: var(--c-surface-hover) !important; }
.leaflet-control-attribution { display: none; }
.truck-marker { transition: transform 0.3s ease; }
`;

export const LEAFLET_DARK_CSS = LEAFLET_CSS;

export type Theme = 'light' | 'dark';

export function getTheme(): Theme {
  const stored = localStorage.getItem('theme');
  if (stored === 'light' || stored === 'dark') return stored;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function setTheme(theme: Theme) {
  localStorage.setItem('theme', theme);
  document.documentElement.classList.toggle('dark', theme === 'dark');
  window.dispatchEvent(new CustomEvent('themechange', { detail: { theme } }));
}

export function toggleTheme(): Theme {
  const next = getTheme() === 'dark' ? 'light' : 'dark';
  setTheme(next);
  return next;
}

export function initTheme() {
  const theme = getTheme();
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

export function isDark(): boolean {
  return document.documentElement.classList.contains('dark');
}

export function getMapTileUrl(): string {
  return isDark()
    ? 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png'
    : 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
}

export function injectStyles(...cssBlocks: string[]) {
  const style = document.createElement('style');
  style.textContent = cssBlocks.join('\n');
  document.head.appendChild(style);
}

export function cdnHead(): string {
  return `
    <script src="https://cdn.tailwindcss.com"></script>
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link href="https://fonts.googleapis.com/css2?family=Inter:opsz,wght@14..32,400;14..32,500;14..32,600;14..32,700;14..32,800&display=swap" rel="stylesheet">
  `;
}
